import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import useSchedulerRecommendations from "../scheduler_recommendations/useSchedulerRecommendations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NewSchedulerRecommendation = (props) => {
  const [contextData, builder] = useContext(VariantContextData);
  const { SchedulerRecommendations } = useSchedulerRecommendations();

  const onClick = (e) => {
    if (
      builder.displayFeatureGate(e, "Conditional Scheduler Recommendations")
    ) {
      SchedulerRecommendations.create(
        props.element,
        {},
        {
          callback: (scheduler_recommendation) => {
            dispatchCustomEvent("focusItem", {
              parent_id: props.element.id,
              item_type: "scheduler_recommendations",
              item_id: scheduler_recommendation.id,
            });
          },
        }
      );
    }
  };

  return (
    <React.Fragment>
      <div className="col-xs-12 mb-5">
        <button
          onClick={onClick}
          className="new-scheduler-recommendation w-full p-2 text-left bg-transparent border-none text-xl text-blue-600 dark:text-blue-200 dark:hover:text-white"
          title="Add Conditional Scheduler"
        >
          <FontAwesomeIcon icon="plus-square" className="mr-2 text-2xl" /> Add
          Conditional Scheduler
        </button>
      </div>
    </React.Fragment>
  );
};

export default NewSchedulerRecommendation;
